<div class="lp-canvas-map" style="width: 100%; height: 100%">
  <lp-canvas-renderer [elements]="elements()" [size]="size()" style="display: block; width: 100%; height: 100%" />
</div>
